import styled from 'styled-components';

export const PolicyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PolicySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
